import React, { useEffect } from 'react'
import LayoutActions from '../redux/actions/LayoutActions'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import UserRoute from '../routers/UserRoute'
import { connect } from 'react-redux'
import { Box } from '@mui/system'
import StockListsLayout from './StockListsLayout'
import StockPrintLayout from './StockPrintLayout'
import { layoutPageComponents as components } from './components/layoutPageComponents'
import { subscribeToRouteSync } from '../utils/routeSyncBridge'

// Resolve which nested layout renders a given settings sub-layout. The print
// group uses StockPrintLayout; everything else falls back to the generic
// StockListsLayout, so existing/new sub-layouts keep working without changes.
const resolveSubLayout = (subLay) => {
    const id = `${subLay?.key || ''} ${subLay?.route || ''}`
    if (/print/i.test(id)) return StockPrintLayout
    return StockListsLayout
}

const stripBase = (path) => {
    const base = window.__ADMIN_STOCK_BASENAME__ || '';
    if (!base) return path;
    if (path === base || path === `${base}/`) return '/';
    if (path.startsWith(`${base}/`)) return path.slice(base.length) || '/';
    return path;
};

function SettingsLayout({
    setPathCheck,
    permission,
    reformat,
    selectedRestaurant
}) {
    const access = reformat(permission.subPage)
        .sort((a, b) => {
            // Check if either 'order' is null
            if (a.order === null && b.order === null) {
                return 0; // Keep the order unchanged if both are null
            } else if (a.order === null) {
                return 1; // Place 'a' (null) after 'b' (non-null)
            } else if (b.order === null) {
                return -1; // Place 'b' (null) after 'a' (non-null)
            }
            // Sort non-null 'order' values normally
            return a.order - b.order;
        });

    useEffect(() => {
        const checkPathname = () => {
            const strippedPathname = stripBase(window.location.pathname);

            const isSubLayoutActive = permission.subLayouts?.some((subLay) =>
                strippedPathname === subLay.route || strippedPathname.startsWith(subLay.route + '/')
            );

            if (!isSubLayoutActive && (strippedPathname === permission.route || strippedPathname.startsWith(permission.route + '/'))) {
                setPathCheck(permission.route);
            }
        };

        return subscribeToRouteSync(checkPathname);
    }, [permission.route, permission.subLayouts, setPathCheck])
console.log(access)
    return (
        <div style={{ height: '100%' }}>
            <Box sx={{ height: '100%' }}>
                <Switch>
                    {/* TEMP: hardcoded until the two statement templates are seeded in the print-settings
                        permission tree. They must stay ABOVE the subLayouts map — the print-settings
                        sub-layout matches `/stock-app/settings/print-settings/*` non-exactly and would
                        otherwise catch these paths and redirect them to not-found. */}
                    <UserRoute
                        exact
                        path="/stock-app/settings/print-settings/customer-statement-print-settings"
                        component={components.customerStatementPrintSettings}
                        permission={permission}
                    />
                    <UserRoute
                        exact
                        path="/stock-app/settings/print-settings/statement-print-settings"
                        component={components.printSupplierStatementSettings}
                        permission={permission}
                    />
                    {permission.subLayouts?.map((subLay, i) => {
                        const SubLayout = resolveSubLayout(subLay)
                        console.log(subLay)
                        return (
                            <Route
                                key={i}
                                path={subLay.route}
                                render={(props) => <SubLayout {...props} permission={subLay} reformat={reformat} />}
                            />
                        )
                    })}
                    <Route exact path="/stock-app/settings" render={() => <Redirect to={access[0]?.route} />} />
                    {access.map((permission2, i) =>
                        <UserRoute key={i} exact path={permission2.route} component={components[permission2.key]} permission={permission2} />
                    )}
                    <UserRoute exact path="/stock-app/settings/po-set" component={components.purchaseInvoicePrintSettings} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/purchase-order-set" component={components.poInvoicePrintSettings} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/transfer-set" component={components.transferPrint} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/wastage-set" component={components.wastagePrint} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/stock-count-set" component={components.printStockCount} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/quotation-set" component={components.quotationPrintSettings} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/sales-set" component={components.salesPrintSettings} permission={permission} />
                    <UserRoute exact path="/stock-app/settings/kitchen-order-set" component={components.kitchenOrderPrintSettingsB2b} permission={permission} />
                    {/* TEMP: hardcoded until productionPrintSettings is seeded in the print-settings permission tree. */}
                    <UserRoute exact path="/stock-app/settings/production-set" component={components.productionPrintSettings} permission={permission} />
                    {/* TEMP: hardcoded until the b2bSalesPricing page is seeded in the settings permission tree. */}
                    <UserRoute exact path="/stock-app/settings/b2b-sales-pricing" component={components.b2bSalesPricing} permission={permission} />
                    {/* TEMP: hardcoded until the stockConfiguration page is seeded in the settings permission tree. */}
                    <UserRoute exact path="/stock-app/settings/stock-configuration" component={components.stockConfiguration} permission={permission} />
                    <Redirect from="*" to="/not-found-2" />
                </Switch>
            </Box>
        </div>
    )
}
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
    setPathCheck: (data) => dispatch(LayoutActions.setPathCheck(data)),
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SettingsLayout))